export enum DialogResponseTypeEnum {
    Confirm,
    Dismiss,
}